module.exports = __webpack_public_path__ + "img/icon_Repost.9876f7a5.svg";